import React from 'react';
import HeroSection from '../components/HeroSection'; // Import the new component

export default function Home() {
  return (
    <>
      <HeroSection />
    </>
  );
}